import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["image"]
  static values = {
    lat: Number,
    lng: Number,
    apiKey: String
  }

  declare readonly imageTarget: HTMLImageElement
  declare readonly latValue: number
  declare readonly lngValue: number
  declare readonly apiKeyValue: string

  connect() {
    this.updateMapImage(this.latValue, this.lngValue)
  }

  updateMarker({ lat, lng }: { lat: number, lng: number }) {
    this.updateMapImage(lat, lng)
  }

  private updateMapImage(lat: number, lng: number) {
    const params = new URLSearchParams({
      center: `${lat},${lng}`,
      zoom: "13",
      size: "640x400",
      scale: "2",
      markers: `${lat},${lng}`,
      key: this.apiKeyValue
    })

    this.imageTarget.src = `https://maps.googleapis.com/maps/api/staticmap?${params.toString()}`
  }
}